import React, {Fragment} from 'react';
import emailjs from 'emailjs-com';
import styles from './ContactForm.module.css';
import Header from './Header';

function ContactForm() {
  function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('service_ji1de1l', 'template_u1yzk57', e.target, 'NSwcs1l_iN3ZChMvX')
      .then((result) => {
        console.log(result.text);
        alert('Email sent successfully!');
      }, (error) => {
        console.log(error.text);
        alert('Error sending email.');
      });

    e.target.reset();
  }

  return (
    <Fragment>
      <Header intro="Contact"></Header>
      <form className={styles.form} onSubmit={sendEmail}>
      <div className={styles.box}>
        <label htmlFor="name">Name: </label>
        <input type="text" name="name" />
      </div>
      <div className={styles.box}>
        <label htmlFor="email">Email: </label>
        <input type="email" name="email" />
      </div>
      <div className={styles.box}>
        <label htmlFor="message">Message: </label>
        <textarea name="message" />
      </div>
      <button type="submit">Send</button>
    </form>
    </Fragment>
    
  );
}

export default ContactForm;
